import { useNavigate } from "react-router-dom";
import React, { useState } from 'react';
import {useDispatch} from 'react-redux'
import  EditLogo from '../../resources/icons/edit.svg';
import { Button } from 'react-bootstrap';
import { deleteTraining } from "../../actions/trainingActions";

import DeleteConfirmationModal from '../modals/DeleteConfirmationModal';

const trainingTypeMap = new Map([['RUNNING','Biegowy'],['ALTERNATIVE','Alernatywny'],['SUPPLEMENTARY','Uzupełniający'],['SUPPLEMENTARY_TECHNICAL','Uzupełnienie techniczne']]);

function TrainingListItem(props) {
   
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  function handleClickEdit(trainingId) {
    navigate(`/trainings/edit/${trainingId}`);
  };

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };
  
  const handleDeleteConfirmed = () => {
    // Dispatch your Redux action for deleting the item
    // ...
    // Close the modal
    dispatch(deleteTraining(props.training.id));
    setShowDeleteModal(false);
  };

  const handleDeleteCanceled = () => {
    // Close the modal without deleting the item
    setShowDeleteModal(false);
  };

  return (
      <tr id={"TR_" + props.training.id}>
        <td>{ new Date(props.training.trainingDate).toLocaleString() }</td>
        <td>{props.training.name}</td>
        <td>{trainingTypeMap.get(props.training.trainingType)}</td>
        <td>{props.training.distance}</td>
        <td>
          <div className="btn-group" role="group" aria-label="Basic example">
            <Button variant="primary" onClick={() => handleClickEdit(props.training.id)}>
              <img src={EditLogo} alt="Edytuj trening"/>
            </Button>
            <Button variant="danger" onClick={() => handleDeleteClick()}>Usuń</Button>
            <DeleteConfirmationModal
              show={showDeleteModal}
              onClose={handleDeleteCanceled}
              onDelete={handleDeleteConfirmed}
            />
          </div>
        </td>
      </tr>
    );
}

export default TrainingListItem;